import { format, parse } from 'date-fns';

export const getBarChartOptions = (categories, selectedPresetKey) => {
  let formattedCategories = categories || [];

  if (categories && categories.length > 0) {
    if (selectedPresetKey === "last_week") {
      formattedCategories = categories.map(cat => {
        try {
          const date = parse(cat, 'yyyy-MM-dd', new Date());
          return format(date, "EEE dd");
        } catch (e) {
          return cat;
        }
      });
    } else if (selectedPresetKey === "last_month" || selectedPresetKey === "last_quarter") {
      formattedCategories = categories.map(cat => {
        try {
          const date = parse(cat, 'yyyy-MM-dd', new Date());
          return format(date, "MMM dd");
        } catch (e) {
          try {
            const date = parse(cat, 'yyyy-MM', new Date());
            return format(date, "MMM ''yy");
          } catch (e2) {
            return cat;
          }
        }
      });
    } else if (selectedPresetKey === "last_6_months" || selectedPresetKey === "last_year") {
      formattedCategories = categories.map(cat => {
        try {
          const date = parse(cat, 'yyyy-MM', new Date());
          return format(date, "MMM ''yy");
        } catch (e) {
          return cat;
        }
      });
    }
  }

  return {
    chart: {
      toolbar: {
        show: false,
      },
      background: "transparent",
    },
    tooltip: {
      style: {
        fontSize: "10px",
        fontFamily: "Sora",
      },
      onDatasetHover: {
        style: {
          fontSize: "10px",
          fontFamily: "Sora",
        },
      },
      theme: "dark",
    },
    xaxis: {
      categories: formattedCategories,
      show: true,
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: true,
        hideOverlappingLabels: false,
        trim: false,
        style: {
          colors: "#c8cfca",
          fontSize: "10px",
          fontFamily: "Sora",
        },
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
    },
    yaxis: {
      show: true,
      labels: {
        show: true,
        style: {
          colors: "#c8cfca",
          fontSize: "10px",
          fontFamily: "Sora",
        },
      },
      title: {
        text: 'LinkedIn Post Volume',
        rotate: -90,
        offsetX: 5,
        style: {
          color: '#c8cfca',
          fontSize: '10px',
          fontFamily: 'Sora',
          fontWeight: 'normal'
        }
      }
    },
    grid: {
      show: true,
      borderColor: "#56577A",
      strokeDashArray: 5,
    },
    fill: {
      colors: ["#2CD9FF", "#0075FF"],
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        grouped: true,
        borderRadius: 5,
        columnWidth: "12px",
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      labels: {
        colors: "#fff",
        useSeriesColors: false,
      },
      floating: false,
      fontFamily: 'Sora',
      markers: {
        size: 6,
        shape: 'circle',
        strokeWidth: 1,
        fillColors: undefined,
        offsetX: -3,
        offsetY: 0
      },
      itemMargin: {
        horizontal: 15,
        vertical: 0
      },
      onItemClick: {
        toggleDataSeries: true
      },
      onItemHover: {
        highlightDataSeries: true
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: {
              borderRadius: 0,
            },
          },
        },
      },
    ],
  };
};
